import React from 'react';
import { bool } from 'prop-types';

// Import components
import { Loader } from 'components/elements';

// Import styles
import {
	RecaptchaContainerWrapper,
	RecaptchaContainer
} from 'components/views/authentication/login/firebase_auth/style';

// Import helpers
import { RECAPTCHA_CONTAINER_ID } from 'components/views/authentication/login/firebase_auth/helpers';

const Recaptcha = ({ isRecaptchaLoading, isCodeFormVisible }) => {
	return (
		<RecaptchaContainerWrapper isVisible={!isCodeFormVisible}>
			<RecaptchaContainer id={RECAPTCHA_CONTAINER_ID} />
			{isRecaptchaLoading && (
				<Loader
					width={8}
					height={8}
					zIndex={100}
					position="absolute"
					background={false}
				/>
			)}
		</RecaptchaContainerWrapper>
	);
};

Recaptcha.propTypes = {
	isRecaptchaLoading: bool.isRequired,
	isCodeFormVisible: bool.isRequired
};

export default Recaptcha;
